import { rem, SecondaryNav } from '@innovyze/stylovyze';
import { Container, Grid, Paper, Typography } from '@mui/material';
import styled from 'styled-components';

export const StyledNewSensor = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	max-width: 1600px;
`;

export default StyledNewSensor;

export const NewSensorPageStyled = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`;

export const BodyGridStyled = styled(Grid)`
	padding-top: ${rem(24)};
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: ${rem(24)};
	row-gap: ${rem(24)};
`;

export const Title = styled(Typography)`
	font-style: normal;
	font-weight: 400;
	font-size: 24px;
	line-height: 32px;
	margin-top: 15px;
	color: #252f33;
	padding: 5px 0px 5px 0px;
`;

export const ContainerStyled = styled(Container)`
	max-width: 1600px;
`;

export const PaperStyled = styled(Paper)`
	display: flex;
	flex-direction: column;
	margin-top: 30px;
`;

export const NavStyled = styled(SecondaryNav)`
	border-bottom-color: #768d95;
`;

export const MapCardStyle = styled('div')`
	height: 400px;
`;
